export default __webpack_public_path__ + "static/media/XRays.2daaf687.png";